import { Box, Container } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import AddUpdateDialog from 'src/components/common/addUpdateDialog'
import FilterSection from 'src/components/common/filterSection'
import AddEditExerciseDetails from 'src/components/exercise/AddExcerciseDetails'
import useQueryTable from 'src/hooks/useQueryTable'
import {
  DeleteExerciseMasterDetailById,
  GetExerciseDetails,
} from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetExerciseDetailTableColumns } from 'src/util/columns'

const ExerciseDetailList = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [recordToEdit, setRecordToEdit] = useState()
  const [customFilterQuery, setCustomFilterQuery] = useState()
  const [searchText, setSearchText] = useState(null)

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })


  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'exerciseDetails',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
    additionalFilters: customFilterQuery,
  })

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const exerciseId = params.get('_id')

    if (exerciseId) {
      setCustomFilterQuery(prev => ({
        ...prev,
        _id: exerciseId,
      }))
    }
  }, [location.search])

  const onDeleteRow = async recordToDelete => {
    if (recordToDelete) {
      await dispatch(DeleteExerciseMasterDetailById(recordToDelete))
      refetch()
    }
  }

  const columns = useMemo(() => GetExerciseDetailTableColumns(), [])

  return (
    <>
      <title>Exercise Details | Langistan</title>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>

          <FilterSection
            type="Practice Item"
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
            dispatcher={GetExerciseDetails}
            setCustomFilterQuery={setCustomFilterQuery}
          />

          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              additionalFilters={customFilterQuery}
              data={data}
              name="Exercise Detail"
              isLoading={isLoading}
              isFetching={isFetching}
              setPagination={setPagination}
            />
          </Box>

          {/* Add & Update practice Item */}
          <AddUpdateDialog
            open={!!recordToEdit}
            title={`${Object.keys(recordToEdit ?? {}).length ? "Update" : "Create"} Practice Item`}
            onClose={() => {
              setRecordToEdit();
            }
            }
            maxWidth="md"
          >
            <Box mt={2}>
              <AddEditExerciseDetails
                selectedRow={recordToEdit}
                toggleDrawer={() => setRecordToEdit()}
                refetch={refetch}
              />
            </Box>
          </AddUpdateDialog>

        </Container>
      </Box>
    </>
  )
}

export default ExerciseDetailList
